// import { Component, OnInit } from '@angular/core';

// @Component({
//   selector: 'app-employer-payment-method',
//   templateUrl: './employer-payment-method.component.html',
//   styleUrls: ['./employer-payment-method.component.scss']
// })
// export class EmployerPaymentMethodComponent implements OnInit {
//   constructor() { }

//   ngOnInit() {
//   }
// }
import { Component, ElementRef, EventEmitter, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AppyUser } from 'src/app/core/model/v2/AppyUser';
import { PaymentProfile } from 'src/app/core/models/UserPaymentProfile/userPaymentProfile';
import { CommonService } from 'src/app/core/services/v2/common.service';
import { UserService } from 'src/app/core/services/v2/user.service';
import { UtilsService } from 'src/app/core/services/v2/utils.service';
import { CreditCardComponent } from 'src/app/market-place/market-place-home/product-checkout/credit-card/credit-card.component';
import { CreditCardPaymentInformation } from 'src/app/physician/models/healthSystemPaymentInformation';
import { PhysicianService } from 'src/app/physician/physician.service';
import { SetupCreditCardFormComponent } from 'src/app/physician/setup/setup-checkout/setup-CreditCard-form/setup-CreditCard-form.component';
import { SideBarInitializeParameters } from 'src/app/shared/components/dynamic-right-sidebar/SideBarInitializeParameters';
import { WindowLoaderService } from 'src/app/shared/components/window-loader/window-loader.service';
import Swal from 'sweetalert2';
// import { CreditCardPaymentInformation } from '../../models/healthSystemPaymentInformation';
// import { PhysicianService } from '../../physician.service';

@Component({
   selector: 'app-employer-payment-method',
   templateUrl: './employer-payment-method.component.html',
   styleUrls: ['./employer-payment-method.component.scss']
})
export class EmployerPaymentMethodComponent implements OnInit {
  @ViewChild('closeModalBtn', { static: false }) closeModalBtn!: ElementRef<HTMLButtonElement>;

  @Output()
  creditCardUpdated = new EventEmitter();
  initialized: boolean = false;
  customerProfileId: string;
  user: AppyUser;
  creditCards: PaymentProfile[];

  creditCardPaymentInformation: CreditCardPaymentInformation;
  constructor(private physicianService: PhysicianService, private loaderService: WindowLoaderService,private commonService : CommonService,
    public dialog: MatDialog,
    private userService: UserService,
    private utils: UtilsService,
    private router: Router,


  ) { }

  ngOnChanges(changes: SimpleChanges) {
    this.GetPaymentInformation()
  }
  ngOnInit() {
    
    this.LoadCheckoutSummary();
    // this.getUser();
    this.GetPaymentInformation();

  }
  private LoadCheckoutSummary() {
    this.loaderService.show();
    this.GetPaymentInformation();
    // this.physicianService.getPaymentInformation().subscribe(
    //   (checkoutSummary) => {
    //     this.creditCardPaymentInformation = checkoutSummary;
    //     this.initialized = true;
    //     this.loaderService.hide();
    //   },
    //   (error) => { console.error(error); this.loaderService.hide(); },
    //   () => { this.loaderService.hide(); });
  }
  // private GetPaymentInformation() {
  //   if (this.user.authorizeNetUserID) {
  //     this.loaderService.blockWithLoader(this.userService.GetPaymentInformation(this.user.authorizeNetUserID)).subscribe(data => {
  //       console.log("Payment Information", data);
  //       console.log("Credit Cards", data.profile.paymentProfiles);
  //       this.creditCards = data.profile.paymentProfiles;
  //       this.customerProfileId = data.profile.customerProfileId
  //     });
  //   }
  // }
  GetPaymentInformation() {
    this.loaderService.blockWithLoader(this.userService.GetPaymentInformation("")).subscribe(data => {
      console.log("Payment Information", data);
      console.log("Credit Cards", data.profile.paymentProfiles);
      if (
        data &&
        data.profile &&
        Array.isArray(data.profile.paymentProfiles) &&
        data.profile.paymentProfiles.length > 0
      ) {
        this.creditCards = [data.profile.paymentProfiles[0]];
      } else {
        this.creditCards = [];
      }
      this.customerProfileId = data.profile.customerProfileId
    });
  
}
  private async getUser() {
    this.userService.getUserDetails().subscribe((userDetail) => {
      this.user = userDetail;
      this.customerProfileId = this.user.authorizeNetUserID;
      this.GetPaymentInformation();
    });
  }
  reload() {
    this.LoadCheckoutSummary();
  }
  AddEditCreditCard()
  {
    const addPracticeManagerData = <SideBarInitializeParameters> {
      componentType: SetupCreditCardFormComponent, 
      onClose : this.creditCardUpdated // this.onClosePracticeManagerSideBar
    };
    this.commonService.rightSideBarComponent$.next(addPracticeManagerData);
  }
  // onConfirmAddCard(): void {
  //   // document.getElementById("clsDisclaimer").click();
  //   ($('#confirmModal') as any).modal('hide');

  //   this.addCreditCard();

  // }
  onConfirmAddCard(): void {
    this.closeModalBtn.nativeElement.click(); // Triggers Bootstrap's data-dismiss
    this.addCreditCard();
  }
  nagivateToSubsciption(): void{
    this.router.navigate(["/employer/subscription"]);

  }
  addCreditCard(): void {
    const dialogRef = this.dialog.open(CreditCardComponent, {
      // height: '45%',
      width: '748px',
      disableClose: true,
      data: this.customerProfileId ? this.customerProfileId : null
    });
    dialogRef.afterClosed().subscribe(res => {
      if (res && res.data && res.data.resultStatus) {
        if (res.data.resultStatus.isSuccess) {
          this.utils.showMessageSnackBar('Credit card saved successfully.');
        }
        else {
          this.utils.showMessageSnackBar(res.data.resultStatus.message, true);
        }
      }
      this.GetPaymentInformation();
    });
  }
  deleteCreditCard(customerPaymentProfileId: string) {
    if (this.customerProfileId) {
      Swal.fire({
        title: `Remove Favorite`,
        text: `Are you sure want to remove this credit card?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Remove!'
      }).then((result) => {
        if (result.isConfirmed) {
          this.loaderService.blockWithLoader(this.userService.DeletePaymentInformation(this.customerProfileId, customerPaymentProfileId)).subscribe(data => {
            this.GetPaymentInformation();
          });
        }
      })

    }
  }
}
